import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "search-info-label" }
const _hoisted_2 = { class: "flex-container-col" }
const _hoisted_3 = { class: "flex-container-row" }
const _hoisted_4 = { class: "flex-container-col" }
const _hoisted_5 = {
  class: "flex-container-row gap10 align-center",
  style: {"margin":"0","padding":"10px 0px 10px 5px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bitmap_link = _resolveComponent("bitmap-link")!
  const _component_my_icon = _resolveComponent("my-icon")!
  const _component_push = _resolveComponent("push")!
  const _component_k_button = _resolveComponent("k-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.localize('LoadProductModelData')) + ":", 1),
    _createElementVNode("div", {
      class: _normalizeClass(["flex-container-row", _ctx.isSmallScreen ? 'flex-wrap' : null])
    }, [
      _createVNode(_component_push, {
        appear: _ctx.showMainModelSeries,
        direction: _ctx.mainDirection
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.isSmallScreen ? 'product-models-container-grid' : 'product-models-container-flow')
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productModels, (model) => {
              return (_openBlock(), _createElementBlock("div", {
                key: model.value,
                class: "flex-container-row",
                style: {"align-self":"flex-start"}
              }, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_bitmap_link, {
                      src: model.bitmapPath,
                      title: model.title,
                      border: false,
                      size: _ctx.isSmallScreen ? null : 200,
                      onClick: ($event: any) => (_ctx.redirectToModel(model))
                    }, null, 8, ["src", "title", "size", "onClick"]),
                    (_ctx.selectedModelSeries?.key === model.key)
                      ? (_openBlock(), _createBlock(_component_my_icon, {
                          key: 0,
                          icon: "arrow-60-right",
                          style: {"align-self":"center"}
                        }))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            }), 128))
          ], 2)
        ]),
        _: 1
      }, 8, ["appear", "direction"]),
      _createVNode(_component_push, {
        appear: _ctx.showSubModelSeries,
        direction: _ctx.subDirection
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_k_button, {
                icon: "arrow-60-left",
                onClick: _ctx.closeSubItems
              }, null, 8, ["onClick"]),
              _createElementVNode("h2", null, _toDisplayString(_ctx.selectedModelSeries?.title), 1)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass([_ctx.isSmallScreen ? 'product-models-container-grid' : 'product-models-container-flow', "product-models-series-container"])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedModelSeries?.subItems ?? [], (model) => {
                return (_openBlock(), _createBlock(_component_bitmap_link, {
                  key: model.value,
                  src: model.bitmapPath,
                  title: model.title,
                  border: false,
                  size: _ctx.isSmallScreen ? null : 180,
                  onClick: ($event: any) => (_ctx.redirectToModel(model))
                }, null, 8, ["src", "title", "size", "onClick"]))
              }), 128))
            ], 2)
          ])
        ]),
        _: 1
      }, 8, ["appear", "direction"])
    ], 2)
  ]))
}